import { AppTimeSeriesResult } from '../dto/top-apps/cube/mapped/app-time-series-result.dto';
import { AppTimeSeriesCubeMetric } from '../enum/cube-schema.enum';
import { TimeSeriesData } from '../dto/common/response/time-series-response.dto';
import { calculateAverage } from '../helpers/duration.helper';

export const mapAppTimeSeriesResult = (
  timeSeriesData: AppTimeSeriesResult[],
  metric: AppTimeSeriesCubeMetric
): TimeSeriesData[] => {
  return timeSeriesData.map((t) => {
    const metricMappings = {
      [AppTimeSeriesCubeMetric.TimeInApp]: Math.round(t.duration),
      [AppTimeSeriesCubeMetric.Interactions]: t.count,
      [AppTimeSeriesCubeMetric.AvgDuration]: Math.round(
        calculateAverage(t.duration, t.count)
      ),
      [AppTimeSeriesCubeMetric.CallTimeInApp]:
        t.callDuration > 0 ? Math.round(t.callDuration) : 0,
      [AppTimeSeriesCubeMetric.CallInteractions]:
        t.callCount > 0 ? t.callCount : 0,
      [AppTimeSeriesCubeMetric.CallAvgDuration]:
        t.callDuration > 0
          ? Math.round(t.callDuration / (t.callCount > 0 ? t.callCount : 1))
          : 0,
    };
    return {
      date: t.date.substring(0, 10),
      value: metricMappings[metric],
    };
  });
};
